import { useEffect, useState } from '@wordpress/element';


const PricingTable = ( { 
	activePlan, 
	title, 
	featureTitle, 
	features, 
	link, 
	linkLtd,
	buttonText, 
	price, 
	addOnTitle,
	addOnText,
	addOnTooltipContent,
	addOnPrice,
	packagesPlan,
	licenseTooltip,
	singleDomain,
	discountNumner,
	percentageImage,
	licenseNumberText,
	freeDocsTooltip,
	enableDiscount,

	agencyLink,
	businessLink,
	growthLink,
	agencyLtdLink,
	businessLtdLink,
	growthLtdLink,
	changeActivePkgBtn

	} ) => {

	const [currentPlanNew, setCurrentPlanNew] = useState(10);
	const [isCheckedPlan, setIsCheckedPlan] = useState(10);

	const [selectedIndex, setSelectedIndex] = useState(1);

	const [ packages, setPackages ] = useState( packagesPlan );
	const [ selectedDataId, setSelectedDataId ] = useState( 1 );

	const handlePlanChangePlan = (newPlan, index) => {
		setSelectedDataId( newPlan?.id );
		setCurrentPlanNew(newPlan);
		setIsCheckedPlan(newPlan);
		setSelectedIndex( index );
	};

	// scroll to download
	const scrollToDownload = () => {
		// Get the link element
		const link = document.querySelector('a[href^="#wedocs_free"]');

		// add eventlistener method
		link?.addEventListener("click", (event) => {
			event.preventDefault();

			// Get the target element
			const targetLink = document.querySelector(
				link.getAttribute("href")
			);

			// Get the position of the target element
			const getBoundRect = targetLink.getBoundingClientRect();

			// Scroll to the position of the target element
			window.scrollTo({
				top: getBoundRect.top + window.pageYOffset,
				left: getBoundRect.left + window.pageXOffset,
				behavior: "smooth",
			});
		});
	};

	const handleAutoClick = () => {
		const getUnlimitedID = document.querySelector('.wedocs-gblocks-pricing-table.lifetime .single-item[for="radio-Unlimited"]');

		setTimeout(() => {
			getUnlimitedID?.click();
		}, 500)
	}

	useEffect( () => {
		setPackages( [ ...packagesPlan ] );

		// scroll to download func
		scrollToDownload()

		// autoClick
		changeActivePkgBtn && (
			handleAutoClick()
		)

	}, [ packagesPlan ] )


	return (
		<>
			<div className={`wedocs-gblocks-pricing-table ${activePlan}`}>
				<div className="wedocs-gblocks-pricing-table-header">
					<h3>{ title }</h3>
				</div>

				<div className="wedocs-gblocks-pricing-table-price">
					<span className='regularPrice'>
						{
							discountNumner && enableDiscount ? (
								<>
									<del>${price}</del>
									${Math.floor( price - ( price * ( discountNumner / 100 ) ) )}<span className='year-text'>/year</span>
								</>
								
							) : (
								
								<>
									${price}<span className='year-text'>/year</span>
								</>
								 
							)
						}
						
					</span>

					{
						activePlan === 'annual' && (
							enableDiscount && (
								percentageImage.url && (
									<div className='perentageImage'>
										{/* {
											percentageImage.url && (
												<img src={percentageImage.url} />
											)
										} */}
										<div className='save-percentage'>
											<div className='save'>
												<label>Save</label> {discountNumner}%
												
											</div>
											<svg xmlns="http://www.w3.org/2000/svg" width="122" height="32" viewBox="0 0 122 32" fill="none">
												<path d="M1.62726 21.3084C1.62726 21.3084 26.4802 -8.46454 58.1909 14.4669C73.868 25.8037 109.739 35.4739 118.43 5.39077" stroke="url(#paint0_linear_1_5)"/>
												<path d="M119.681 2.04739L115.215 5.57523L121.044 7.22548L119.681 2.04739Z" fill="#2086FF"/>
												<defs>
												<linearGradient id="paint0_linear_1_5" x1="123.986" y1="-19.8183" x2="5.168" y2="32.0606" gradientUnits="userSpaceOnUse">
												<stop stop-color="#0075FF"/>
												<stop offset="1" stop-color="#0075FF" stop-opacity="0"/>
												</linearGradient>
												</defs>
											</svg>
										</div>
									</div>
								)
							)
						)
					} 

					{
						activePlan === 'annual' && (
							enableDiscount && (
								packages && packages?.map( pkg => (
									selectedDataId === pkg?.id && pkg?.annualPackageDiscount && 
									
									<div className='save-percentage professional-discount'>
										<div className='save'>
											<label>Save</label> {pkg.annualPackageDiscount}%
											
										</div>
										<svg xmlns="http://www.w3.org/2000/svg" width="122" height="32" viewBox="0 0 122 32" fill="none">
											<path d="M1.62726 21.3084C1.62726 21.3084 26.4802 -8.46454 58.1909 14.4669C73.868 25.8037 109.739 35.4739 118.43 5.39077" stroke="url(#paint0_linear_1_5)"/>
											<path d="M119.681 2.04739L115.215 5.57523L121.044 7.22548L119.681 2.04739Z" fill="#2086FF"/>
											<defs>
											<linearGradient id="paint0_linear_1_5" x1="123.986" y1="-19.8183" x2="5.168" y2="32.0606" gradientUnits="userSpaceOnUse">
											<stop stop-color="#0075FF"/>
											<stop offset="1" stop-color="#0075FF" stop-opacity="0"/>
											</linearGradient>
											</defs>
										</svg>
									</div>
									
									
									
								) )
							)
							
						)
					} 

					{
						activePlan === 'lifetime' && (
							enableDiscount && (
								packages && packages?.map( pkg => (
									selectedDataId === pkg?.id && pkg?.lifeTimePackageDiscount && 
									<div className='save-percentage professional-discount'>
										<div className='save'>
											<label>Save</label> {pkg.lifeTimePackageDiscount}%
											
										</div>
										<svg xmlns="http://www.w3.org/2000/svg" width="122" height="32" viewBox="0 0 122 32" fill="none">
											<path d="M1.62726 21.3084C1.62726 21.3084 26.4802 -8.46454 58.1909 14.4669C73.868 25.8037 109.739 35.4739 118.43 5.39077" stroke="url(#paint0_linear_1_5)"/>
											<path d="M119.681 2.04739L115.215 5.57523L121.044 7.22548L119.681 2.04739Z" fill="#2086FF"/>
											<defs>
											<linearGradient id="paint0_linear_1_5" x1="123.986" y1="-19.8183" x2="5.168" y2="32.0606" gradientUnits="userSpaceOnUse">
											<stop stop-color="#0075FF"/>
											<stop offset="1" stop-color="#0075FF" stop-opacity="0"/>
											</linearGradient>
											</defs>
										</svg>
									</div>
									
								) )
							)
							
						)
					} 

					{
						activePlan === 'annual' && (
							packages && packages?.map( pkg => (
								selectedDataId === pkg?.id && pkg?.monthPrice && 
									<span className='package-plan'>
										{
											discountNumner && enableDiscount ? (
												<>
													<del>${pkg?.monthPrice}</del>
													${Math.floor( pkg?.monthPrice - ( pkg?.monthPrice * ( pkg.annualPackageDiscount / 100 ) ) )}<span className='year-text'>/year</span>
												</>
											) : (
												<>
													${pkg?.monthPrice}<span className='year-text'>/year</span>
												</>
											)
										}
										
									</span>
							) )
						)
					}

					{
						activePlan === 'lifetime' && (
							packages && packages?.map( pkg => (
								selectedDataId === pkg?.id && pkg?.yearPrice && 
								<span className='package-plan'>
									{
										discountNumner && enableDiscount ? (
											<>
												<del>${pkg?.yearPrice}</del>
												${Math.floor( pkg?.yearPrice - ( pkg?.yearPrice * ( pkg.lifeTimePackageDiscount / 100 ) ) )}<span className='year-text'>/year</span>
											</>
										) : (
											<>
												${pkg?.yearPrice}<span className='year-text'>/year</span>
											</>
										)
									}
								</span>
							) )
						)
					}
					
					
				</div>

				<div className="wedocs-gblocks-pricing-table-features">
					{ licenseNumberText && (
						<div className='tooltipWraper'>
							<span className="wedocs-gblocks-pricing-table-features-title">
								{ licenseNumberText }

								{
									licenseTooltip && (
										<div className='tooltipIcon'>
											<svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
												<path d="M10.998 6V10M10.998 14H11.008M19.998 10C19.998 14.9706 15.9686 19 10.998 19C6.02748 19 1.99805 14.9706 1.99805 10C1.99805 5.02944 6.02748 1 10.998 1C15.9686 1 19.998 5.02944 19.998 10Z" stroke="#4A6474" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
											</svg>
											{
												
												licenseTooltip && (
													<div className='tooltipContent'>
														<p>{licenseTooltip}</p>
													</div>
												)
											}
										</div>
									)
								}

								
							</span>
						</div>
					) }

					<div className="pricing-tab">
						{packagesPlan.map((item, index) => (
							<>
								<input key={item.id} name="pricing-tab" type="radio" id={`radio-${item.packageName}`} checked={item == isCheckedPlan ? 'checked' : ''} />
								<div 
									key={item.id}
									data-id={ item.id }
									className={`single-item ${item.packageName == currentPlanNew ? 'active' : ''}`}
									onClick={() => handlePlanChangePlan(item, index)}
									for={`radio-${item.packageName}`}
								>

									{item.packageName}
									
								</div>
							
							</>
						))}
						<span class="tab-slider"></span>
					</div>
					
					{
						singleDomain && (
							<div className='single-domain'>{singleDomain}</div>
						)
					}

					<div className="wedocs-gblocks-pricing-table-cta single-button">
						<button data-fs-id={link} className="cta-annual fastspring-buy-button">
						{ buttonText }
						</button>
						<button data-fs-id={linkLtd} className="cta-lifetime fastspring-buy-button" >
						{ buttonText }
						</button>
						
					</div>

					<div className="wedocs-gblocks-pricing-table-cta package-button-group annual-btn-group">
						<div className={`single-button-item ${selectedIndex === 0 ? 'active' : ''}`}>
							<button data-fs-id={agencyLink} className="fastspring-buy-button" >{ buttonText }</button>
						</div>
						<div className={`single-button-item ${selectedIndex === 1 ? 'active' : ''}`}>
							<button data-fs-id={businessLink} className="fastspring-buy-button" >{ buttonText }</button>
						</div>
						<div className={`single-button-item ${selectedIndex === 2 ? 'active' : ''}`}>
						<button data-fs-id={growthLink} className="fastspring-buy-button" >{ buttonText }</button>
						</div>
					</div>

					<div className="wedocs-gblocks-pricing-table-cta package-button-group lifetime-btn-group">
						<div className={`single-button-item ${selectedIndex === 0 ? 'active' : ''}`}>
							<button data-fs-id={agencyLtdLink} className="fastspring-buy-button" >{ buttonText }</button>
						</div>
						<div className={`single-button-item ${selectedIndex === 1 ? 'active' : ''}`}>
							<button data-fs-id={businessLtdLink} className="fastspring-buy-button" >{ buttonText }</button>
						</div>
						<div className={`single-button-item ${selectedIndex === 2 ? 'active' : ''}`}>
							<button data-fs-id={growthLtdLink} className="fastspring-buy-button" >{ buttonText }</button>
						</div>
						
					</div>
						
					<ul className='feature-list'>
						{
							featureTitle && (
								<h3>
									<span
										dangerouslySetInnerHTML={ {
											__html: featureTitle,
										} }
									></span>
									
									{
										freeDocsTooltip && (
											<div className='tooltipIcon'>
												{/* <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
													<path d="M10.998 6V10M10.998 14H11.008M19.998 10C19.998 14.9706 15.9686 19 10.998 19C6.02748 19 1.99805 14.9706 1.99805 10C1.99805 5.02944 6.02748 1 10.998 1C15.9686 1 19.998 5.02944 19.998 10Z" stroke="#4A6474" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
												</svg> */}
												<div className='free-docs-tooltip'>
													<ul>
														{
															freeDocsTooltip.map((item, i) => (
																<li key={ i }>
																	<svg
																		width="12"
																		height="8"
																		fill="none"
																		xmlns="http://www.w3.org/2000/svg"
																	>
																		<path
																			d="M4.497 7.505a.49.49 0 0 1-.347-.144L1.144 4.355a.49.49 0 1 1 .694-.694L4.497 6.32 10.162.655a.49.49 0 1 1 .694.694L4.844 7.36a.49.49 0 0 1-.347.144Z"
																			fill="#ffffff"
																			stroke="#ffffff"
																			strokeWidth=".3"
																		/>
																	</svg>
																	<span
																		dangerouslySetInnerHTML={ {
																			__html: item,
																		} }
																	></span>
																</li>
															))
														}
													</ul>
												</div>
											</div>
										)
									}
									
									
								</h3>
							)
						}
						{ features.map( ( list ) => (
							<>
								
								<li>
									<div className='check-icon'>
										<svg xmlns="http://www.w3.org/2000/svg" width="29" height="28" viewBox="0 0 29 28" fill="none">
											<path d="M27.956 14C27.956 21.4558 21.9119 27.5 14.456 27.5C7.00021 27.5 0.956055 21.4558 0.956055 14C0.956055 6.54416 7.00021 0.5 14.456 0.5C21.9119 0.5 27.956 6.54416 27.956 14Z" stroke="#0075FF"/>
											<path fill-rule="evenodd" clip-rule="evenodd" d="M18.5528 12.4321C19.0264 11.9585 19.0264 11.1906 18.5528 10.717C18.0792 10.2434 17.3113 10.2434 16.8377 10.717L12.8443 14.7104L11.2763 13.1425C10.8027 12.6689 10.0349 12.6689 9.56126 13.1425C9.08765 13.6161 9.08765 14.384 9.56126 14.8576L11.9867 17.283C12.4603 17.7567 13.2282 17.7567 13.7018 17.283L18.5528 12.4321Z" fill="#0075FF"/>
										</svg>
									</div>
									<div className='single-item'>
										{
											list.title && (
												<h4>{list.title}</h4>
											)
										}
										<p>
											{list.text}

											{
												list.tooltipContent && (
													<div className='tooltip-area'>
														<div className='tooltipIcon'>
															<svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
																<path d="M10.998 6V10M10.998 14H11.008M19.998 10C19.998 14.9706 15.9686 19 10.998 19C6.02748 19 1.99805 14.9706 1.99805 10C1.99805 5.02944 6.02748 1 10.998 1C15.9686 1 19.998 5.02944 19.998 10Z" stroke="#4A6474" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
															</svg>
															<div className='tooltipContent'>
																<p>{list.tooltipContent}</p>
															</div>
														</div>
														
													</div>
													
												)
												
											}
										</p>
										
									</div>
								</li>
							</>
						) ) }
					</ul>
					<div className='footer-button'>
						<div className="wedocs-gblocks-pricing-table-cta">
							<button data-fs-id={link} className="cta-annual fastspring-buy-button" >
							{ buttonText }
							</button>
							<button data-fs-id={linkLtd} className="cta-lifetime fastspring-buy-button" >
							{ buttonText }
							</button>
							
						</div>


						<div className="wedocs-gblocks-pricing-table-cta package-button-group annual-btn-group">
							<div className={`single-button-item ${selectedIndex === 0 ? 'active' : ''}`}>
								<button data-fs-id="wedocs-agency" className="fastspring-buy-button" >{ buttonText }</button>
							</div>
							<div className={`single-button-item ${selectedIndex === 1 ? 'active' : ''}`}>
								<button data-fs-id="wedocs-business" className="fastspring-buy-button" >{ buttonText }</button>
							</div>
							<div className={`single-button-item ${selectedIndex === 2 ? 'active' : ''}`}>
							<button data-fs-id="wedocs-growth" className="fastspring-buy-button" >{ buttonText }</button>
							</div>
						</div>

						<div className="wedocs-gblocks-pricing-table-cta package-button-group lifetime-btn-group">
							<div className={`single-button-item ${selectedIndex === 0 ? 'active' : ''}`}>
								<button data-fs-id="wedocs-pro-ltd-agency" className="fastspring-buy-button" >{ buttonText }</button>
							</div>
							<div className={`single-button-item ${selectedIndex === 1 ? 'active' : ''}`}>
								<button data-fs-id="wedocs-pro-ltd-business" className="fastspring-buy-button" >{ buttonText }</button>
							</div>
							<div className={`single-button-item ${selectedIndex === 2 ? 'active' : ''}`}>
								<button data-fs-id="wedocs-pro-ltd-growth" className="fastspring-buy-button" >{ buttonText }</button>
							</div>
							
						</div>

					</div>
					{
						addOnTitle && (
							<div className='addon-price-wrap'>
								<div className='add-text'>
									<h4>
										{ addOnTitle }

										{
											addOnTooltipContent && (
												<div className='tooltipIcon'>
													<svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
														<path d="M10.998 6V10M10.998 14H11.008M19.998 10C19.998 14.9706 15.9686 19 10.998 19C6.02748 19 1.99805 14.9706 1.99805 10C1.99805 5.02944 6.02748 1 10.998 1C15.9686 1 19.998 5.02944 19.998 10Z" stroke="#4A6474" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
													</svg>
													{
														addOnTooltipContent && (
															<div className='tooltipContent'>
																<p>{addOnTooltipContent}</p>
															</div>
														)
													}
												</div>
											)
										}
									</h4>
									

									{
										addOnText && (
											<p>{addOnText}</p>
										)
									}
								</div>
								{
									addOnPrice && (
										<div className='addon-price'>
											<p>${addOnPrice} <span>/mo</span></p>
										</div>
									)
								}
								
							</div>
						)
					}
					
				</div>
				
			</div>
		</>
	);
};


export default PricingTable;